import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
        <CardsSection />
        <FaqSection />
        <IndexSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}